<template>
  <div
    class="budgetbar__container"
    :title="
      `${
        percentOfTotal > 1
          ? `${percentOfTotal.toFixed(0)}% of total`
          : `< 1% of total`
      }${
        otherAmount > 0
          ? ' (including spending from SOEs/public institutions)'
          : ''
      }`
    "
  >
    <div class="budgetbar">
      <div class="budgetbar__bar" :style="{ width: `${percent}%` }" />
      <div
        class="budgetbar__bar budgetbar__bar--private"
        :style="{ width: `${otherPercent}%` }"
      />
    </div>
    <div
      class="budgetbar__amount"
      :class="{ 'budgetbar__amount--other': amount === 0 && otherAmount > 0 }"
    >
      {{ formattedAmount }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    amount: {
      type: Number,
      required: true
    },
    otherAmount: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  },
  computed: {
    percent() {
      return (this.amount / this.max) * 100;
    },
    otherPercent() {
      return (this.otherAmount / this.max) * 100;
    },
    percentOfTotal() {
      return ((this.amount + this.otherAmount) / this.total) * 100;
    },
    formattedAmount() {
      if (this.amount === 0 && this.otherAmount > 0)
        return (this.otherAmount * 1000).toLocaleString("FR", {
          maximumFractionDigits: 0
        });
      return this.amount < 0.001
        ? "< 1"
        : (this.amount * 1000).toLocaleString("FR", {
            maximumFractionDigits: 0
          });
    }
  }
};
</script>

<style scoped>
.budgetbar__container {
  width: 100%;
  position: relative;
  display: flex;
}
.budgetbar {
  flex: 1 0 auto;
  position: relative;
  margin-right: 8px;
  display: flex;
}
.budgetbar__bar {
  background: #04f;
  height: 16px;
}
.budgetbar__bar--private {
  background: #04f;
  opacity: 0.5;
}
.budgetbar__amount {
  flex: 0 0 auto;
}
.budgetbar__amount--other {
  font-style: italic;
}
tr:hover .budgetbar__bar {
  background: #fff;
}
</style>
